import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function ShippingForm({ clientName, clientSurname, deliveryAddress, handleDeliveryAddressChange }) {
  const { t } = useTranslation();

  return (
    <>
      <hr className="pt-3" />
      <h5 className="pb-3">{t("msg_shipping_within_germany")}</h5>

      <hr className="pt-3" />
      <h5 className="pb-3">{t("msg_least_10_days_shipping")}</h5>

      <hr className="pt-3" />
      <h3 className="pb-3">{t("shipping_address")}</h3>

      <Form>
        <input type="hidden" name="customerName" value={clientName} />
        <input type="hidden" name="customerLastname" value={clientSurname} />

        <Row>
          <Col md={6} sm={12}>
            <Form.Group className="mb-3" controlId="formName">
              <Form.Label>{t("name")}</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={deliveryAddress.name}
                onChange={handleDeliveryAddressChange}
                required
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3" controlId="formLastname">
              <Form.Label>{t("lastname")}</Form.Label>
              <Form.Control
                type="text"
                name="lastname"
                value={deliveryAddress.lastname}
                onChange={handleDeliveryAddressChange}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={6} sm={12}>
            <Form.Group className="mb-3" controlId="formAdditionalAddress">
              <Form.Label>{t("additional_address")}</Form.Label>
              <Form.Control
                type="text"
                name="additional_address"
                value={deliveryAddress.additional_address}
                onChange={handleDeliveryAddressChange}
              />
            </Form.Group>
          </Col>

          <Col md={6} sm={12}>
            <Form.Group className="mb-3" controlId="formPostalCode">
              <Form.Label>{t("postal_code")}</Form.Label>
              <Form.Control
                type="text"
                name="postal_code"
                value={deliveryAddress.postal_code}
                onChange={handleDeliveryAddressChange}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={6} sm={12}>
            <Form.Group className="mb-3" controlId="formAddress">
              <Form.Label>{t("address")}</Form.Label>
              <Form.Control
                type="text"
                name="address"
                value={deliveryAddress.address}
                onChange={handleDeliveryAddressChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={6} sm={12}>
            <Form.Group className="mb-3" controlId="formNumber">
              <Form.Label>{t("number")}</Form.Label>
              <Form.Control
                type="text"
                name="number"
                value={deliveryAddress.number}
                onChange={handleDeliveryAddressChange}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={6} sm={12}>
            <Form.Group className="mb-3" controlId="formCity">
              <Form.Label>{t("city")}</Form.Label>
              <Form.Control
                type="text"
                name="city"
                value={deliveryAddress.city}
                onChange={handleDeliveryAddressChange}
                required
              />
            </Form.Group>
          </Col>

          <Col md={6} sm={12}>
            <Form.Group className="mb-3" controlId="formCountry">
              <Form.Label>{t("country")}</Form.Label>
              <Form.Control
                type="text"
                name="country"
                value={deliveryAddress.country}
                onChange={handleDeliveryAddressChange}
                required
                disabled
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default ShippingForm;
